<i class="icon-search search-bar-icon"></i>
<mat-form-field class="mat-search">
  <mat-chip-grid #chipList>
    <input
      placeholder="Search"
      #fruitInput
      [formControl]="fruitCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur"
      (matChipInputTokenEnd)="add($event)">
    </mat-chip-grid>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      @for (fruit of filteredFruits | async; track fruit) {
        <mat-option [value]="fruit">
          {{fruit}}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

